import { LiquidityData } from '@/features/futures/types';
import { IFuturesOrderBookItem } from './futures';
// Removed unused type: ChartItem
export interface DepthChartData {
  tick: number;
  price: number;
  base: number;
}

// Removed unused type: AccountChartItem
export type PieChartItem = {
  name: string;
  value: number | string;
  color: string;
};
export type IExtendDepthChartData = IFuturesOrderBookItem & {
  isShowIcon?: boolean;
};
export interface IDepthChartData {
  left: DepthChartData[];
  right: DepthChartData[];
}
export interface ILiqChartConvertedData extends LiquidityData {
  liqNumber: number;
}

// Removed unused type alias: ITvlAndVolumeChartData

// Removed unused interface: IFundingChartData

export enum KlineInterval {
  MINUTE = '1m',
  FIVE_MINUTE = '5m',
  FIFTEEN_MINUTE = '15m',
  THIRTY_MINUTE = '30m',
  HOUR = '1h',
  FOUR_HOUR = '4h',
  WEEK = '1w',
  DAY = '1d',
  MONTH = '1M',
}
